/**
 * Created by Jerker Nord on 2019-03-12.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ThorGameConfig} from "../../ThorGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ThorGameAssets} from "../../ThorGameAssets";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {TimelineLite, TweenLite} from "gsap";
import {ThorGameModuleConfig} from "../../ThorGameModuleConfig";
import {IconState, IIconView} from "../IIconView";

export class ThorMultiplierIconView extends BaseView implements IIconView {
    get fsIconIsVisible():boolean {
        return this._fsIconIsVisible;
    }
    set fsIconIsVisible(value:boolean) {
        this._fsIconIsVisible = value;
        this.onResize(this._resizeData);
    }
    private _fsIconIsVisible:boolean = false;

    private static MULTIPLIER_CONTAINER_LANDSCAPE_POSITION:PIXI.Point = new PIXI.Point(1104, 15);
    private static MULTIPLIER_CONTAINER_PORTRAIT_POSITION:PIXI.Point = new PIXI.Point(584, -91);
    public static thorMultiplierIconView:ThorMultiplierIconView;

    private _multiplierIconX1Disabled:PIXI.Sprite;
    private _multiplierIconX1Enabled:PIXI.Sprite;
    private _multiplierIconX2:PIXI.Sprite;
    private _multiplierIconX3:PIXI.Sprite;
    private _multiplierIconX4:PIXI.Sprite;
    private _multiplierContainer:PIXI.Container;
    private _multiplierPositions:PIXI.Point[] = [new PIXI.Point(0, 0), new PIXI.Point(-5, 0), new PIXI.Point(-5, 0), new PIXI.Point(-5, 0)];
    private _multiplierIcons:PIXI.Sprite[];
    private _currentMultiplier:PIXI.Sprite;
    private _state:IconState;
    private _layer:ScalableLayer;
    private _enableRandomWildIconSelectTL:TimelineLite;

    constructor() {
        super();
        this._layer = StageManager.getLayer(ThorGameConfig.instance.LAYERS.SCATTER_ANIMATION.name);
        this._layer.addChild(this);
        this._multiplierContainer = new PIXI.Container();
        this.addChild(this._multiplierContainer);
        this._state = IconState.disabled;
        ThorMultiplierIconView.thorMultiplierIconView = this;
    }

    protected onResize(resizeData:IResizeData):void {
        if(resizeData.orientation == Orientation.PORTRAIT) {
            this._multiplierContainer.position = ThorMultiplierIconView.MULTIPLIER_CONTAINER_PORTRAIT_POSITION;
            if (!this.fsIconIsVisible){
                this._multiplierContainer.position.x = ThorMultiplierIconView.MULTIPLIER_CONTAINER_PORTRAIT_POSITION.x + 130;
            }
            this._multiplierContainer.scale.set(1.2, 1.2);
        } else {
            this._multiplierContainer.position = ThorMultiplierIconView.MULTIPLIER_CONTAINER_LANDSCAPE_POSITION;
            this._multiplierContainer.scale.set(1, 1);
        }
    }

    protected initAnimations():void {
        this._multiplierIcons = [];
        this._multiplierIconX1Disabled = new PIXI.Sprite(GameResources.getTextures(ThorGameAssets.ICON_MULTIPLIER_X1_DISABLED)[0]);
        this._multiplierIconX1Disabled.position = this._multiplierPositions[0];
        this._multiplierContainer.addChild(this._multiplierIconX1Disabled);
        this._multiplierIcons.push(this._multiplierIconX1Disabled);
        this._currentMultiplier = this._multiplierIconX1Disabled;

        this._multiplierIconX1Enabled = new PIXI.Sprite(GameResources.getTextures(ThorGameAssets.ICON_MULTIPLIER_X1_ENABLED)[0]);
        this._multiplierIconX1Enabled.position = this._multiplierPositions[0];
        this._multiplierIconX1Enabled.alpha = 0;
        this._multiplierContainer.addChild(this._multiplierIconX1Enabled);

        this._multiplierIconX2 = new PIXI.Sprite(GameResources.getTextures(ThorGameAssets.ICON_MULTIPLIER_X2)[0]);
        this._multiplierIconX2.alpha = 0;
        this._multiplierIconX2.position = this._multiplierPositions[1];
        this._multiplierContainer.addChild(this._multiplierIconX2);
        this._multiplierIcons.push(this._multiplierIconX2);

        this._multiplierIconX3 = new PIXI.Sprite(GameResources.getTextures(ThorGameAssets.ICON_MULTIPLIER_X3)[0]);
        this._multiplierIconX3.alpha = 0;
        this._multiplierIconX3.position = this._multiplierPositions[2];
        this._multiplierContainer.addChild(this._multiplierIconX3);
        this._multiplierIcons.push(this._multiplierIconX3);

        this._multiplierIconX4 = new PIXI.Sprite(GameResources.getTextures(ThorGameAssets.ICON_MULTIPLIER_X4)[0]);
        this._multiplierIconX4.alpha = 0;
        this._multiplierIconX4.position = this._multiplierPositions[3];
        this._multiplierContainer.addChild(this._multiplierIconX4);
        this._multiplierIcons.push(this._multiplierIconX4);
    }

    public abort():void {
        if(this._enableRandomWildIconSelectTL && this._enableRandomWildIconSelectTL.isActive()) {
            this._enableRandomWildIconSelectTL.pause();
            this._enableRandomWildIconSelectTL.kill();
        }
    }

    public enableMultiplierIconTL(multiplierLevel:number, isFreeSpin:boolean):TimelineLite {
        if(this._enableRandomWildIconSelectTL && this._enableRandomWildIconSelectTL.isActive()) {
            this._enableRandomWildIconSelectTL.pause();
            this._enableRandomWildIconSelectTL.kill();
        }
        this._enableRandomWildIconSelectTL = new TimelineLite();
        this._enableRandomWildIconSelectTL.add(ThorGameModuleConfig.thorMjolnirtimeView.getIconSelectAnimation(0, isFreeSpin));
        this._enableRandomWildIconSelectTL.add(() => this.activateMultiplier(multiplierLevel), "-=0.6");

        return this._enableRandomWildIconSelectTL;
    }

    public activateMultiplier(multiplierLevel:number):void {
        for(let i:number = 0; i < this._multiplierIcons.length; i++) {
            if((multiplierLevel - 1) == i) {
                this._multiplierIcons[i].alpha = 1;
                this._currentMultiplier = this._multiplierIcons[i];
            } else {
                this._multiplierIcons[i].alpha = 0;
            }
        }
    }

    public disableMultiplierIconTL(delay:number):TimelineLite {
        const timeLine:TimelineLite = new TimelineLite({delay : delay});
        timeLine.add(() => this._multiplierIconX1Enabled.alpha = 0);
        timeLine.add([
            new TweenLite(this._currentMultiplier, 0.4, {alpha : 0}),
            new TweenLite(this._multiplierIconX1Disabled, 0.2, {alpha : 1})
        ]);
        timeLine.add(() => this.setState(IconState.disabled));

        return timeLine;
    }

    public getState():IconState {
        return this._state;
    }

    public setState(state:IconState):void {
        this._state = state;
        switch(state) {
            case IconState.disabled:
                this._multiplierIconX1Disabled.alpha = 1;
                this._multiplierIconX1Enabled.alpha = 0;
                break;
            case IconState.enabled:
                this._multiplierIconX1Enabled.alpha = 1;
                this._multiplierIconX1Disabled.alpha = 0;
                break;
            case IconState.activated:
                this._multiplierIconX1Enabled.alpha = 1;
                this._multiplierIconX1Disabled.alpha = 0;
                break;
            default:
                debugger;
                throw new Error("IconStates.setState(): Illegal icon state " + state);
        }
    }
}